<template>
  <div class="resignation">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">My Team Store Requisitions</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Expense</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <!-- <router-link
                  to="/add-expense"
                  class="btn add-btn"
                  ><i class="fa fa-plus"></i> Add Expense Claim</router-link
                > -->
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <v-data-table
                  :headers="headers"
                  :items="sortedStoreRequisition"
                  sort-by=""
                  class="elevation-1"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <router-link
                          :to="{
                            name: 'editStoreRequisition',
                            params: { id: item.id }
                          }"
                          class="dropdown-item"
                          ><i class="fa fa-pencil m-r-5"></i> View</router-link
                        >
                        <a
                          class="dropdown-item"
                          @click="openDialogStatus(item)"
                          v-if="
                            item.status == 0 &&
                              item.approvedByManager == null &&
                              isManager
                          "
                          ><i class="fa fa-check"></i> Approve or Reject</a
                        >
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.description`]="{ item }">
                    {{
                      item.description ? item.description.substring(0, 25) : ''
                    }}
                  </template>
                  <template v-slot:[`item.profile`]="{ item }">
                    <h2 class="table-avatar blue-link">
                      <router-link to="/profile" class="avatar"
                        ><img alt="" src="~@/assets/profiles/avatar-02.jpg"
                      /></router-link>
                      <router-link to="/profile">{{
                        `${item.requester.firstName} ${item.requester.lastName}`
                      }}</router-link>
                    </h2>
                  </template>
                  <template v-slot:[`item.requestDate`]="{ item }">
                    {{
                      item.requestDate
                        ? new Date(item.requestDate).toLocaleDateString()
                        : item.requestDate
                    }}
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 7"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Awaiting
                      Submission
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Awaiting
                      Approval
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Approved
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 2"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-danger"></i> Declined
                    </a>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Delete Resignation Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <button type="button" class="close" @click="closeDelete">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h3>Delete Requisition</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click.prevent="deleteExpenseClaim"
                      class="btn btn-primary continue-btn"
                      data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      data-dismiss="modal"
                      @click="closeDelete"
                      class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Resignation Modal -->
        <!-- Approve Leave Modal -->
        <v-dialog v-model="dialogStatus" max-width="500px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Requisition Approve</h3>
                <p>Are you sure want to approve for this requisition?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click="changeExpenseStatus(1)"
                      class="btn btn-primary continue-btn"
                      >Approve</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      @click="changeExpenseStatus(2)"
                      data-dismiss="modal"
                      class="btn btn-primary cancel-btn"
                      >Decline</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Approve Leave Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/employeeSidebar.vue";
import { required, sameAs } from "vuelidate/lib/validators";
import { employeeService } from "@/services/employeeService.js";
import Datepicker from "vuejs-datepicker";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },

  data() {
    return {
      dialogDelete: false,
      dialogStatus: false,
      headers: [
        {
          text: "Employee",
          align: "start",
          value: "profile"
        },
        { text: "Remark", value: "description" },
        { text: "Date", value: "requestDate" },
        { text: "Status", value: "status" },
        { text: "", value: "actions", sortable: false }
      ],
      name: "",
      employeeId: "",
      remark: "",
      amount: "",
      assignee: "",
      assigneeId: "",
      expenseTypeId: 0,
      date: "",
      // resignationDate: "",
      // resignation: {},
      expenses: [],
      expenseTypes: [],
      expense: {},
      employee: [],
      loading: false,
      isManager: false,
      error: "",
      employees: [],
      submitted: false,
      user: authenticationService.currentUserValue,
      company: authenticationService.currentOfficeValue,
      file: null,
      fileName: null
    };
  },

  validations: {
    name: { required },
    reason: { required },
    date: { required },
    assignee: { required }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    },
    dialogStatus(val) {
      val || this.closeStatus();
    }
  },
  computed: {
    sortedStoreRequisition: function() {
      function compare(a, b) {
        if (
          new Date(a.requestDate).getTime() < new Date(b.requestDate).getTime()
        )
          return 1;
        if (
          new Date(a.requestDate).getTime() > new Date(b.requestDate).getTime()
        )
          return -1;
        return 0;
      }

      return this.expenses ? this.expenses.sort(compare) : this.expenses;
    }
  },
  methods: {
    clearModel() {
      this.date = "";
      this.remark = "";
      this.amount = "";
      this.assigneeId = "";
      this.file = null;
      this.fileName = null;
    },
    isEmployeeManager() {
      employeeService.isEmployeeManager().then(model => {
        this.isManager = model;
      });
    },
    onFilePicked(event) {
      const files = event.target.files;
      this.fileName = files[0].name;
      //   // console.log(this.fileName)
      // const fileReader = new FileReader()
      // fileReader.addEventListener('load', () => {
      // 	this.file = fileReader.result
      // })
      // fileReader.readAsDataURL(files[0])
      this.file = files[0];
    },

    changeFile() {
      this.file = null;
      this.fileName = "";
    },

    getEmployees() {
      const companyId = this.company.id;
      //console.log('this.company.id', this.company.id)
      employeeService.getEmployees(companyId).then(
        model => {
          this.employees = model;
          // console.log(model)
        },
        error => {
          error = error;
        }
      );
    },
    getTypes() {
      const companyId = this.company.id;
      //console.log('this.company.id', this.company.id)
      employeeService.getExpenseType(companyId).then(
        model => {
          this.expenseTypes = model;
          // console.log(model)
        },
        error => {
          error = error;
        }
      );
    },
    changeExpenseStatus(status) {
      this.submitted = true;
      this.expense.status = status;
      if (status == 1) {
        this.expense.approvedBy =
          this.user.employee.firstName + " " + this.user.employee.lastName;
        this.expense.approvedDate = new Date();
      }
      this.loading = true;
      employeeService.updateStoreRequisition(this.expense).then(
        id => {
          var id = this.user.employee.id;
          employeeService.getStoreRequisitionByTeam(id).then(model => {
            console.log(model);
            this.expenses = model;
            this.closeStatus();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    getStoreRequisition() {
      var id = this.user.employee.id;
      employeeService.getStoreRequisitionByTeam(id).then(
        model => {
          console.log(model);
          this.expenses = model;
        },
        error => {
          error = error;
        }
      );
    },
    //   var userId = this.user.employee.id
    //   employeeService.getExpenseClaimByEmployee(userId).then(
    //     (model) => {
    //       console.log(model)
    //       this.expenses = model;
    //     },
    //     (error) => {
    //       error = error;
    //     }
    //   )
    // },
    openDialog() {
      this.dialog = true;
    },
    openDialogStatus(item) {
      this.expense = item;
      this.dialogStatus = true;
    },
    close() {
      this.dialog = false;
      this.clearModel();
    },
    closeStatus() {
      this.dialogStatus = false;
      this.clearModel();
    },
    closeEdit() {
      this.dialogEdit = false;
      this.clearModel();
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    setEditExpense(model) {
      this.expense = model;
      var Name = model.document.split("/");
      this.fileName = Name.length > 0 ? Name[Name.length - 1] : null;
      this.dialogEdit = true;
    },
    setDeleteExpense(model) {
      this.expense = model;
      this.dialogDelete = true;
    },
    deleteExpenseClaim() {
      this.loading = true;
      const id = this.expense.id;
      employee.removeStoreRequisition(id).then(
        id => {
          var id = this.user.employee.id;
          employeeService.getStoreRequisitionByTeam(id).then(w => {
            (this.expenses = w), console.log(w);
            this.closeDelete();
          });
        },
        e => {
          this.error = e;
          this.loading = false;
          this.closeDelete();
        }
      );
    }
  },

  mounted() {
    this.isEmployeeManager();
    this.getStoreRequisition();
    this.getEmployees();
    this.getTypes();

    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "expensereports"
};
</script>



// WEBPACK FOOTER //
// src/components/expenses/StoreRequisition/listForManager.vue